import * as React from 'react';
import SvgIm404 from '../widgets/svgs/SvgIm404';
import { styled } from '../theme';
import { ButtonType, ButtonWidget } from '../widgets/buttons/ButtonWidget';
import { Link } from 'react-router-dom';

export interface NotFoundProps {
  backPath: string;
}

export const NotFound: React.FC<NotFoundProps> = (props) => {
  return (
    <S.Container>
      <S.CenterBox>
        <SvgIm404 />
        <S.TextContainer>
          <S.Text primary={true}>Oh no!</S.Text>
          <S.Text primary={false}>This page does not exist</S.Text>
          <S.LinkWidget to={props.backPath}>
            <S.Button label={'Back to home'} type={ButtonType.SECONDARY} action={() => {}} />
          </S.LinkWidget>
        </S.TextContainer>
      </S.CenterBox>
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  `;

  export const CenterBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
  `;

  export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 24px;
  `;

  export const Text = styled.div<{ primary: boolean }>`
    font-size: 16px;
    text-align: center;
    color: ${(p) => (p.primary ? p.theme.text.primary : p.theme.text.secondary)};
    user-select: none;
  `;

  export const Button = styled(ButtonWidget)`
    margin-top: 16px;
  `;

  export const LinkWidget = styled(Link)`
    text-decoration: none;
  `;
}
